(function () {
  'use strict';

  // Find config — scoped by section ID
  const configEl = document.querySelector('script[id^="mahj-preview-config-"]');
  if (!configEl) return;

  const config = JSON.parse(configEl.textContent);
  console.log('[MAHJ PREVIEW] config:', JSON.stringify(config, null, 2));
  const sectionId = config.sectionId;
  const scale = config.previewWidth / config.artboard.width;

  // Elements
  const canvas = document.getElementById('mahj-preview-canvas-' + sectionId);
  if (!canvas) return;
  const ctx = canvas.getContext('2d');

  // Auto-size canvas from artboard ratio
  canvas.width = config.previewWidth;
  canvas.height = Math.round(config.previewWidth * config.artboard.height / config.artboard.width);

  const previewSlide = canvas.closest('.mahj-preview-slide');

  // Resolve inputs for all fields
  var fields = config.fields;
  var inputs = [];
  for (var i = 0; i < fields.length; i++) {
    var el = document.getElementById(fields[i].inputId);
    if (!el) return;
    inputs.push(el);
  }

  // State
  let currentColorVariant = resolveColorFromOption(config.currentColorOption);
  let bgImages = {};
  let bgLoaded = {};
  let fontReady = false;
  let hasShownPreview = false;

  // Resolve light/dark from color option name (e.g. "lavender" → "light")
  function resolveColorFromOption(colorName) {
    var key = String(colorName || '').toLowerCase();
    return config.colorOptionMap[key] || config.colorOptionMap['_default'] || 'dark';
  }

  // Preload background images
  Object.keys(config.backgrounds).forEach(function (variant) {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      bgLoaded[variant] = true;
      if (variant === currentColorVariant && hasAnyText()) {
        render();
      }
    };
    img.src = config.backgrounds[variant];
    bgImages[variant] = img;
  });

  function hasAnyText() {
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value.trim()) return true;
    }
    return false;
  }

  // Load fonts then mark ready
  document.fonts.ready.then(function () {
    var loads = [];
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      var fontSpec = f.fontWeight + ' ' + Math.round(f.fontSize * scale) + 'px "' + f.fontFamily + '"';
      loads.push(document.fonts.load(fontSpec));
    }
    return Promise.all(loads);
  }).then(function () {
    fontReady = true;
    if (hasAnyText()) render();
  });

  function render() {
    var variant = currentColorVariant;

    // Clear
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Fill background color if specified (wall art)
    if (config.backgroundColor) {
      var bgColor = config.backgroundColor[variant] || config.backgroundColor['_default'];
      if (bgColor) {
        ctx.fillStyle = bgColor;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
      }
    }

    // Draw background / overlay image
    if (bgLoaded[variant]) {
      ctx.drawImage(bgImages[variant], 0, 0, canvas.width, canvas.height);
    }

    // Draw text for each field
    if (fontReady) {
      for (var i = 0; i < fields.length; i++) {
        var field = fields[i];
        var text = inputs[i].value.trim();
        if (!text) continue;
        if (field.uppercase) text = text.toUpperCase();
        if (field.prefix) text = field.prefix + text;
        if (field.suffix) text = text + field.suffix;

        var fontSize = Math.round(field.fontSize * scale);
        ctx.font = (field.fontStyle || 'normal') + ' ' + field.fontWeight + ' ' + fontSize + 'px "' + field.fontFamily + '"';
        ctx.fillStyle = field.colors[variant] || field.colors['dark'];
        ctx.textAlign = field.textAlign || 'center';
        ctx.textBaseline = field.textBaseline || 'middle';

        var x = Math.round(field.x * scale);
        var y = Math.round(field.y * scale);

        if (field.wrapOnSpace && text.indexOf(' ') !== -1) {
          var lh = Math.round((field.lineHeight || field.fontSize) * scale);
          var lines = text.split(/\s+/);
          for (var l = 0; l < lines.length; l++) {
            ctx.fillText(lines[l], x, y + l * lh);
          }
        } else if (field.maxWidth) {
          var maxW = Math.round(field.maxWidth * scale);
          var lh = Math.round((field.lineHeight || field.fontSize) * scale);
          var words = text.split(/\s+/);
          var lines = [];
          var line = '';
          for (var w = 0; w < words.length; w++) {
            var test = line ? line + ' ' + words[w] : words[w];
            if (ctx.measureText(test).width > maxW && line) {
              lines.push(line);
              line = words[w];
            } else {
              line = test;
            }
          }
          if (line) lines.push(line);
          for (var l = 0; l < lines.length; l++) {
            ctx.fillText(lines[l], x, y + l * lh);
          }
        } else {
          ctx.fillText(text, x, y);
        }
      }
    }
  }

  function showPreviewSlide() {
    if (hasShownPreview || !previewSlide) return;
    hasShownPreview = true;
    previewSlide.removeAttribute('style');
    previewSlide.style.display = 'block';
    requestAnimationFrame(function () {
      previewSlide.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  // Listen for input on all fields
  for (var i = 0; i < inputs.length; i++) {
    inputs[i].addEventListener('input', function () {
      if (hasAnyText()) {
        showPreviewSlide();
      }
      render();
    });
  }

  // Listen for variant changes via Dawn's PubSub system
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (variant && variant.option1) {
        currentColorVariant = resolveColorFromOption(variant.option1);
        render();
      }
    });
  }
})();
